import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  heading: string;
  description?: string;
}

export function EmptyState({ icon, heading, description }: EmptyStateProps) {
  return (
    <div className="py-16 flex flex-col items-center justify-center">
      {icon && <div className="text-ink-5 mb-3">{icon}</div>}
      <div className="text-[15px] font-medium text-ink-3">{heading}</div>
      {description && (
        <div className="text-[13px] text-ink-4 mt-1 text-center max-w-sm">{description}</div>
      )}
    </div>
  );
}
